import { enumToStaticValue } from '@/utils'
import { OutcomeStockMovementType } from './outcomeStockMovementType'

export default enumToStaticValue(OutcomeStockMovementType, 'outcome-stock-movement-type')
